<template>
    <div id="ap">
        <a-layout>
            <div class="content-header">
                <a-affix :offset-top="0" style="width: 100%;">
                    <a-row type="flex" justify="space-between">
                        <a-col span="8">
                            <common-page-btn @verify="$refs.orderVerifyRef.show()"></common-page-btn>
                        </a-col>
                        <a-col span="16">
                            <a-row type="flex" align="middle" justify="end" :gutter="10">
                                <a-col span="6">
                                    <a-input v-model="param.keyword" allowClear search @pressEnter="getList"
                                        @on-clear="getList" placeholder="关键词查询"></a-input>
                                </a-col>
                                <a-col span="8">
                                    <choose-organ v-model="param.organId" @change="organChange"
                                        allowClear></choose-organ>
                                </a-col>
                                <a-col span="6">
                                    <a-select v-model="param.cateId" placeholder="类别筛选" style="width: 100%"
                                        @change="doRefresh">
                                        <a-select-option :value="item.cateId" v-for="item in category"
                                            :key="item.cateId">
                                            {{ item.name }}
                                        </a-select-option>
                                    </a-select>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-row>
                </a-affix>
            </div>
        </a-layout>

        <a-layout>
            <a-layout-content>
                <a-table :defaultExpandAllRows="true" :scroll="{ x: '100%' }" :pagination="false" :indentSize="25"
                    :style="{ background: '#FFF' }" size="small" row-key="sn" border :columns="keys" ref="list"
                    :loading="loading" :data-source="data.records">
                    <template slot-scope="row" slot="user">
                        <a-space>
                            <!-- <a-avatar :src="row.avatar" size="small"></a-avatar> -->
                            <a>{{ row.nickName }}</a>
                        </a-space>
                    </template>
                    <template slot-scope="row" slot="phone">
                        <a-space>
                            <show-phone :phone="row.phone"></show-phone>
                        </a-space>
                    </template>
                    <template slot-scope="row" slot="goods">
                        <a-space>
                            <span>{{ row.goodsName }}</span>
                        </a-space>
                    </template>
                    <template slot-scope="row" slot="number">
                        <span>x {{ row.number }}</span>
                    </template>
                    <template slot-scope="row" slot="action">
                        <a-button-group shape="circle" size="small">
                            <a-tooltip title="编辑"><a-button type="link" v-has="'grade-mall:goods:save'" icon="edit"
                                    @click="$refs.goodsFormRef.show(row)"></a-button></a-tooltip>
                            <a-tooltip title="删除"><a-button type="link" v-has="'grade-mall:goods:delete'" icon="delete"
                                    @click="del(row.goodsId)"></a-button></a-tooltip>
                        </a-button-group>
                    </template>
                </a-table>
            </a-layout-content>
        </a-layout>
        <a-row>
            <a-col span="12" offset="6" style="text-align: center; padding: 20px 0;">
                <a-pagination :defaultPageSize="param.limit" :total="data.total" @change="getNext"
                    @showSizeChange="setLimit" :current="data.current" />
            </a-col>
        </a-row>
        <goods-cate-list ref="cateListRef" @close="getCategory()"></goods-cate-list>
        <goods-form ref="goodsFormRef" :category="category" @success="doRefresh" />
        <order-verify ref="orderVerifyRef" @success="doRefresh"></order-verify>
    </div>
</template>

<script>
import apiUtil from "@/common/apiUtil";
import utils from '@/common/utils';
import goodsCateList from "./components/goods-cate-list.vue";
import goodsForm from './components/goods-form.vue'
import orderVerify from './components/order-verify.vue'
export default {
    components: { goodsCateList, goodsForm, orderVerify },
    data() {
        return {
            confirmLoading: false,
            visible: false,
            loading: false,
            isExamine: true,
            cause: '',
            storeId: null,
            status: '',
            data: { records: [] },
            param: {
                page: 1,
                limit: 20,
                keyword: '',
                organId: apiUtil.getDefaultOrganId(),
                cateId: ''
            },
            organList: apiUtil.getOrganList(),
            keys: [
                { title: '订单号', dataIndex: 'sn', ellipsis: true },
                { title: '用户昵称', scopedSlots: { customRender: 'user' }, width: 160, align: 'center', ellipsis: true },
                { title: '手机电话', scopedSlots: { customRender: 'phone' }, width: 160, align: 'center', ellipsis: true },
                { title: '兑换物品', scopedSlots: { customRender: 'goods' }, tooltip: true, align: 'left', ellipsis: true },
                { title: '兑换数量', scopedSlots: { customRender: 'number' }, width: 120, tooltip: true, align: 'center', ellipsis: true },
                { title: '消耗积分', dataIndex: 'grade', width: 160, align: 'center', ellipsis: true },
                { title: '兑换时间', dataIndex: 'createTime', width: 160, align: 'center', ellipsis: true },
                { title: '状态', dataIndex: 'status', width: 160, align: 'center', ellipsis: true },
                // { title: '操作', scopedSlots: { customRender: 'action' }, align: 'center', width: 200 }
            ],
            category: []
        };
    },
    created() {
        this.doRefresh();
    },
    methods: {
        organChange() {
            this.param.cateId = '';
            this.doRefresh();
        },
        // 获取数据
        getList() {
            this.loading = true;
            this.http
                .get('/platform/goods-order/list', this.param)
                .then(ret => {
                    console.log(ret);
                    this.data = ret.data;
                }).finally(() => {
                    this.loading = false;
                });
        },
        doRefresh() {
            this.param.page = 1;
            this.getList();
        },
        //设置每页的显示条数
        setLimit(current, limit) {
            this.param.page = 1;
            this.param.limit = limit;
        },
        //页码切换
        getNext(page) {
            this.param.page = page;
            this.getList();
        }
    }
};
</script>

<style scoped></style>
